import React, { useEffect, useState } from "react";
import "./Sections.scss";
import Agenda from "../Agenda/Agenda";
import Map from "../Map/Map";
import Faq from "../Faq/Faq";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useHashScroll } from "./ScrollToHashElement";

// speakers
import speaker1 from "../../assets/SHERAZADISHVILI Nikoloz_.png";
import speaker2 from "../../assets/TOMMY MACIAS.png";
// import speaker3 from "../../assets/kotsoiev.png";
// sponsors
import sponsor1 from "../../assets/sponsor-1.png";
import sponsor2 from "../../assets/sponsor-2.png";
import sponsor3 from "../../assets/sponsor-3.png";
import sponsor4 from "../../assets/sponsor-4.png";
import sponsor5 from "../../assets/sponsor-5.png";
import sponsor6 from "../../assets/sponsor-6.png";

import location1 from "../../assets/arena.jpeg";
import kimonoIcon from "../../assets/kimono-icon.png";
import medalIcon from "../../assets/medal-icon.png";
import contactImg from "../../assets/contact-img.jpeg";
import checkmark from "../../assets/checkmark.svg";
import hotelRoom from "../../assets/hotel-room-5.jpg";
import iconPlay from "../../assets/icon-play.svg";

const speakerImages = [speaker2, speaker1];

function Sections() {
  const location = useLocation();
  useHashScroll(location);

  const { t, i18n } = useTranslation();

  const speakersRaw = t("speakersSection.speakers", { returnObjects: true });
  const speakers = Array.isArray(speakersRaw) ? speakersRaw : [];

  const ticketsRaw = t("priceSection.tickets", { returnObjects: true });
  const tickets = Array.isArray(ticketsRaw) ? ticketsRaw : [];

  const [modalData, setModalData] = useState(null);

  useEffect(() => {
    // testing modal:
    // setModalData({
    //   modalType: "success",
    //   message: t("contactForm.successMessage"),
    // })

    if (location.state?.modalType) {
      setModalData(location.state);
      // Optionally clear state from history after showing
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  // useEffect(() => {
  //   if (location.hash) {
  //     const id = location.hash.replace("#", "");
  //     const element = document.getElementById(id);
  //     if (element) {
  //       // Timeout is to ensure DOM is fully rendered before scroll
  //       setTimeout(() => {
  //         element.scrollIntoView({ behavior: "smooth" });
  //       }, 100);
  //     }
  //   }
  // }, [location]);


  return (
    <div className="sections-container">
      {modalData && (
        <div className={`modal ${modalData.modalType}`}>
          <div className="modal-content">
            <p>{modalData.message}</p>
            <button onClick={() => setModalData(null)}>Close</button>
          </div>
        </div>
      )}
      <section id="speakers" className="section-speakers">
        {/* <h1>{t("speakersSection.title")}</h1> */}

        {/* this part of section is removed for now */}
        {/* <div className="img-container">
          <img src={speakersMainImg} alt="" className="header-img" />
        </div>
        <hr /> */}
        <h1>{t("speakersSection.subtitle2")}</h1>
        {/* <div className="text-container">
          <p className="text-large">{t("speakersSection.subtitle2")}</p>
          <div className="text-small">{t("speakersSection.description")}</div>
        </div> */}

        <div className="speakers-images">
          {speakers.map((speaker, index) => (
            <div key={speaker.name} className="speaker-card">
              <div className="speaker-flip">
                <div className="front">
                  <img src={speakerImages[index]} alt={speaker.name} />

                  <button className="flip-indicator">
                    {t("speakersSection.moreInfo")}
                  </button>
                </div>
                <div className="back">
                  <div className="about-info">
                    <h3>{speaker.name}</h3>
                    <p>{speaker.about}</p>
                  </div>
                </div>
              </div>

              <div className="achievements-container">
                <div className="achievement">
                  <span>
                    <img
                      src={index == 2 ? kimonoIcon : medalIcon}
                      className="icon"
                      alt=""
                    />
                  </span>
                  {speaker.achievement1}
                </div>
                <div className="achievement">
                  <span>
                    <img
                      src={index == 2 ? kimonoIcon : medalIcon}
                      className="icon"
                      alt=""
                    />
                  </span>
                  {speaker.achievement2}
                </div>
                {/* <div className="achievement">
                  <span>
                    <img
                      src={index == 2 ? kimonoIcon : medalIcon}
                      className="icon"
                      alt=""
                    />
                  </span>
                  {speaker.achievement3}
                </div> */}
              </div>

              {/* <div className="link-container">
                <a
                  href={speaker.highlights}
                  className="button-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span>
                    <img src={iconPlay} alt="Icon Play" />
                  </span>
                  <span>Highlights</span>
                </a>

                <li className="highlights-link">
                  <span>
                    <img src={iconPlay} alt="Icon Play" />
                  </span>
                  <a
                    href={speaker.highlights}
                    className="button-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Highlights
                  </a>
                </li>
              </div> */}
            </div>
          ))}
        </div>
      </section>

      {/* section SPONSORS */}
      {/* <section className="section-sponsors">
            <h3>{t("sponsorsSection.sponsoredBy")}</h3>
            <div className="sponsors-container">
              <div className="sponsor">
                <p>{t("sponsorsSection.placeForYourAds")}</p>
              </div>
              <div className="sponsor">
              <p>{t("sponsorsSection.placeForYourAds")}</p>

              </div>
              <div className="sponsor">
              <p>{t("sponsorsSection.placeForYourAds")}</p>

              </div>
              <div className="sponsor">
              <p>{t("sponsorsSection.placeForYourAds")}</p>

              </div>

            </div>
          </section> */}
      <section className="section-sponsors">
        {/* <div className="sponsor">
              

              <img src={sponsor1} alt="" />
            </div> */}
        <h3>{t("sponsorsSection.sponsoredBy")}</h3>
        <div className="sponsors-container">
          {[...Array(2)].map((_, index) => (
            // Duplicate for infinite effect
            <React.Fragment key={index}>


              <div className="sponsor">


                <img src={sponsor1} alt="" />
              </div>
              <div className="sponsor">
                <img src={sponsor2} alt="" />
              </div>
              <div className="sponsor">
                <img src={sponsor3} alt="" />
              </div>
              <div className="sponsor">
                <img src={sponsor4} alt="" />
              </div>
              <div className="sponsor">
                <img src={sponsor5} alt="" />
              </div>
              <div className="sponsor">
                <img src={sponsor6} alt="" />
              </div>
              {/* <div className="sponsor">
                <p>{t("sponsorsSection.placeForYourAds")}</p>
              </div> */}
            </React.Fragment>
          ))}
        </div>
      </section>

      {/* section SCHEDULE */}
      <section id="schedule" className="section-schedule">
        <h1 className="has-text-below">{t("schedule")}</h1>
        <p className="applicationEndDate">{t("scheduleChange")}</p>
        {/* <div className="text-container">
          <p className="text-large">{t("scheduleSection.description")}</p>
        </div> */}
        <Agenda />
      </section>

      {/* section LOCATIONS */}
      <section id="locations" className="section-locations">
        <h1>{t("locations")}</h1>
        {/* <div className="locations-images">
          <img src={location1} alt="Location 1" />
          <img src={hotelRoom} alt="Location 2" />
        </div> */}
        <div className="locations-images">
          <div className="location-item">
            <img src={location1} alt="Location 1" />
            <div className="overlay">
              <h3>Tatami</h3>
              <p>Ustanička 125</p>
              <div className="link">
                <a
                  href="https://www.google.com/maps/place/Ustani%C4%8Dka+125,+Beograd+11000,+Serbia/@44.786227,20.4820914,16.95z/data=!4m6!3m5!1s0x475a706176bae6bf:0x33dafcedde4bb23e!8m2!3d44.7847557!4d20.4848781!16s%2Fg%2F11kx25d24h?entry=ttu&g_ep=EgoyMDI1MDQwNi4wIKXMDSoJLDEwMjExNjM5SAFQAw%3D%3D"
                  className="show-on-map"
                  target="_blank"
                >
                  {t("locationsSection.showOnMap")}
                </a>
              </div>
            </div>
          </div>

          <div className="location-item">
            <img src={hotelRoom} alt="Location 2" />
            <div className="overlay">
              <h3>Hotel</h3>
              <p>Ustanička 127c</p>
              <div className="link">
                <a
                  href="https://www.google.com/maps/place/Ustani%C4%8Dka+127c,+Beograd+11010,+Serbia/@44.784569,20.4916667,17z/data=!3m1!4b1!4m6!3m5!1s0x475a70894310000b:0xdb4431e53449fbdf!8m2!3d44.784569!4d20.494247!16s%2Fg%2F11rg60lkny?entry=ttu&g_ep=EgoyMDI1MDQwNi4wIKXMDSoJLDEwMjExNjM5SAFQAw%3D%3D"
                  className="show-on-map"
                  target="_blank"
                >
                  {t("locationsSection.showOnMap")}
                </a>
              </div>
            </div>
          </div>
        </div>

        <Map />
      </section>

      {/* section PRICE */}
      <section id="price" className="pricing-section">
        <h1 className="has-text-below">{t("price")}</h1>
        {/* <p className="applicationEndDate">
          {t("applicationEndDate1")}
          <span>{t("applicationEndDate2")}</span>
        </p> */}

        <div className="pricing-cards">
          {tickets.map((ticket) => (
            <div className="pricing-card" key={ticket.name}>
              <h3 className="card-title">{t(ticket.name)}</h3>
              <p className="card-subtitle">{t(ticket.description)}</p>
              <hr />

              {/* <p className={`price price-${i18n.language}`}>
                {t(ticket.price)}
              </p> */}
              <div className={`price-container price-${i18n.language}`}>
                <p className={`price price-${ticket.name.toLowerCase()}`}>
                  {t(ticket.price)}
                </p>
                <p className="price-note">{t(ticket.priceNote)}</p>
              </div>

              <Link to="/contact" className="contact-link">
                <button className="btn" style={{ textTransform: "uppercase" }}>
                  {t("signUp")}
                </button>
              </Link>
              <hr className="hr-second" />
              <ul className="features">
                {ticket.features.map((feature) => (
                  <li key={feature}>
                    <span className="checkmark">
                      <img src={checkmark} alt="" />
                    </span>
                    {t(feature)}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="discount">
          <p>
            {t("discount1")}
            <span>{t("discount2")}</span>
            {t("discount3")}
          </p>
        </div>
      </section>

      {/* section FAQ */}
      <section id="faq" className="section-faq">
        <h1>{t("faqSection.title")}</h1>
        {/* <div className="text-container">
          <p className="text-large">{t("faqSection.description")}</p>
        </div> */}

        <Faq />
      </section>

      {/* section CONTACT */}
      <section id="contact" className="section-contact">
        <h1 className="has-text-below">{t("contact")}</h1>
        <div className="text-container">
          <p className="text-large">{t("contactSection.description")}</p>
        </div>

        <div className="contact-container">
          <div className="contact-info">
            <h2>{t("contact")}</h2>
            <h3>Email</h3>
            <p>
              <a href="mailto:kukoljmasterclass@gmail.com">
                kukoljmasterclass@gmail.com
              </a>
            </p>
            <h3>Instagram</h3>
            <p>
              <a
                href="https://instagram.com/kukoljmasterclass"
                target="_blank"
                rel="noopener noreferrer"
              >
                @kukoljmasterclass
              </a>
            </p>

            <h3>{t("contactSection.location")}</h3>

            <p>{t("contactSection.address")}</p>
          </div>

          <div className="contact-image">
            <img src={contactImg} alt="Contact" />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Sections;
